import { Box, Text, VStack, HStack, Badge, Divider } from "@chakra-ui/layout";
import { FormControl, FormLabel, useColorModeValue } from "@chakra-ui/react";

import { ProductStructure, ProductType } from "doxecure-commons/doxecureTypes";

import { G1Input } from "@components/G1Input";
import { G1Icon } from "@/utils/icons";

interface SubscriptionStepProps {
    // isAloneUser: Nullable<boolean>;
    // nbCollaborators: number;
    partnerCode?: string;
    subscriptionProduct?: ProductStructure;
    packProducts?: ProductStructure[];
    // onAloneUserChange: (value: boolean) => void;
    // onCollaboratorsChange: (valueAsString: string, valueAsNumber: number) => void;
    onPartnerCodeChange: (code: string) => void;
}

export const SubscriptionStep = (props: SubscriptionStepProps) => {
    const {
        subscriptionProduct,
        packProducts,
        // isAloneUser,
        // nbCollaborators,
        partnerCode,
        // onAloneUserChange,
        // onCollaboratorsChange,
        onPartnerCodeChange,
    } = props;

    const collaboratorProduct = packProducts?.find(p => p.type === ProductType.Collaborator);
    // const limitedBorderColor = useColorModeValue("blue.400", "blue.100");
    // const limitedBgColor = useColorModeValue("blue.50", "blue.400");
    // const limitedActiveTextColor = useColorModeValue("blue.600", "blue.100");
    const textColor = useColorModeValue("gray.100", "gray.400");
    const titleColor = useColorModeValue("blue.700", "blue.100");
    const priceColor = useColorModeValue("blue.600", "blue.200");
    const dividerColor = useColorModeValue("blue.200", "blue.700");
    const featureIconBg = useColorModeValue("blue.400", "blue.300"); // 👈 sorti du map


    return (
        <VStack spacing={3}>
            <Box
                width="100%"
                borderWidth="2px"
                borderRadius="xl"
                borderColor="blue.400"
                bg="blue.400"
                p={{ base: 4, md: 8 }}
                position="relative"
                overflow="hidden"
            >
                <Badge
                    position="absolute"
                    top={4}
                    right={4}
                    colorScheme="blue"
                    variant="solid"
                    borderRadius="full"
                    px={3}
                    py={1}
                    fontSize="xs"
                    textTransform="uppercase"
                    letterSpacing="wide"
                >
                    Offre unique
                </Badge>

                <VStack align="flex-start" spacing={1} mb={6}>
                    <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color={titleColor}>{subscriptionProduct?.label}</Text>
                    <Text fontSize={{ base: "xs", md: "sm" }} color={textColor} fontStyle="italic">{subscriptionProduct?.description}</Text>
                    <HStack align="baseline" spacing={1} mt={2}>
                        <Text fontSize={{ base: "3xl", md: "4xl" }} fontWeight="extrabold" color={priceColor}>{subscriptionProduct?.price}€</Text>
                        <Text fontSize="sm" color={textColor}>HT / an</Text>
                    </HStack>
                </VStack>

                <Divider borderColor={dividerColor} mb={4} />

                <VStack align="flex-start" spacing={2}>
                    {subscriptionProduct?.features.map((feature) => (
                        <HStack key={feature} spacing={3}>
                            <Box
                                borderRadius="full"
                                bg={featureIconBg}
                                p={1}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <G1Icon.Check color="white" />
                            </Box>
                            <Text className="btn-text" fontSize={["xs", "sm"]} color={textColor}>
                                {feature}
                            </Text>
                        </HStack>
                    ))}
                </VStack>
            </Box>

            <FormControl>
                <FormLabel fontSize="1.25em">Code partenaire</FormLabel>
                <G1Input
                    component="connection.form"
                    value={partnerCode}
                    textTransform="uppercase"
                    onChange={(e) => onPartnerCodeChange(e.target.value)}
                />
            </FormControl>

            <Box mt={5} p={4} bg="orange.900" border="1px solid" borderColor="orange.600" borderRadius="md">
                <Text fontSize="md" color="orange.100" lineHeight="1.7">
                    ⚠️ Durant la période d'essai, vous avez la possibilité d'inscrire 4 autres collaborateurs. A la fin de cette période, chaque collaborateur inscrit et actif sera facturé {collaboratorProduct?.price}€ HT / an.
                </Text>
            </Box>
            {/* <FormControl isRequired>
                <FormLabel fontSize="1.25em">Nombre de collaborateurs à inclure</FormLabel>
                <HStack spacing={4} alignSelf="flex-start">
                    <Text>Etes-vous le seul utilisateur du parapheur ?</Text>
                    <Button
                        size="sm" borderWidth="2px" borderRadius="lg"
                        borderColor={isAloneUser === true ? limitedBorderColor : "gray.200"}
                        bg={isAloneUser === true ? limitedBgColor : "transparent"}
                        color={isAloneUser === true ? limitedActiveTextColor : textColor}
                        _hover={{ borderColor: limitedBorderColor, bg: limitedBgColor, color: limitedActiveTextColor }}
                        transition="all 0.2s"
                        onClick={() => onAloneUserChange(true)}
                    >Oui</Button>
                    <Button
                        size="sm" borderWidth="2px" borderRadius="lg"
                        borderColor={isAloneUser === false ? limitedBorderColor : "gray.200"}
                        bg={isAloneUser === false ? limitedBgColor : "transparent"}
                        color={isAloneUser === false ? limitedActiveTextColor : textColor}
                        _hover={{ borderColor: limitedBorderColor, bg: limitedBgColor, color: limitedActiveTextColor }}
                        transition="all 0.2s"
                        onClick={() => onAloneUserChange(false)}
                    >Non</Button>
                </HStack>

                {isAloneUser === false && (
                    <HStack align="stretch" alignSelf="flex-start" alignItems="center" mt={2}>
                        <Text>Nombre de collaborateurs supplémentaires :</Text>
                        <NumberInput value={nbCollaborators} min={0} step={1} onChange={onCollaboratorsChange} size="md">
                            <NumberInputField
                                minW="70px"
                                width={`${Math.max(70, nbCollaborators.toString().length * 16 + 40)}px`}
                                textAlign="center"
                                fontWeight="semibold"
                                fontSize="md"
                                borderRadius="lg"
                                borderWidth="2px"
                                bg={$g1Color(`form.field.bg`)}
                                color={$g1Color(`form.field.write`)}
                                borderColor={$g1Color(`form.field.border`)}
                                _hover={{ borderColor: $g1Color(`form.field.hover.border`) }}
                                _focus={{ borderColor: $g1Color(`form.field.select.border`), boxShadow: "none" }}
                            />
                            <NumberInputStepper borderWidth="0" flexDirection="column" width="28px">
                                    <NumberIncrementStepper border="none" borderRadius="md" mx="1" my="0.5" bg="blue.400" color="white" fontSize="xs" fontWeight="bold" _hover={{ bg: "blue.500", transform: "scale(1.1)" }} _active={{ bg: "blue.600", transform: "scale(0.95)" }} transition="all 0.15s">＋</NumberIncrementStepper>
                                    <NumberDecrementStepper border="none" borderRadius="md" mx="1" my="0.5" bg="gray.200" color="gray.600" fontSize="xs" fontWeight="bold" _hover={{ bg: "gray.300", transform: "scale(1.1)" }} _active={{ bg: "gray.400", transform: "scale(0.95)" }} transition="all 0.15s">－</NumberDecrementStepper>
                            </NumberInputStepper>
                        </NumberInput>
                        <Text>* 60€ HT</Text>
                    </HStack>
                )}
            </FormControl> */}
        </VStack>
    );
};